import React, { ReactNode } from "react"
import styled from "styled-components"

type StyledProps = {
  $padding?: string
  $margin?: string
  $overflow?: string
}

const StyledBox = styled.div<StyledProps>`
  overflow: ${(p) => p.$overflow};
  padding: ${(p) => p.$padding};
  margin: ${(p) => p.$margin};
  border-radius: 0.5rem;
  width: 100%;
`

type Props = {
  children: ReactNode | ReactNode[]
  padding?: string
  margin?: string
  overflow?: string
}

const Box = ({
  children,
  padding = "4rem",
  margin = "0.5rem 1rem",
  overflow = "visible"
}: Props) => {
  return (
    <StyledBox $padding={padding} $margin={margin} $overflow={overflow}>
      {children}
    </StyledBox>
  )
}

export default Box
